/** nb-NO date/time display with a manual fallback (iOS 10 Intl safety). */
const MONTHS = [
  'jan.',
  'feb.',
  'mars',
  'apr.',
  'mai',
  'juni',
  'juli',
  'aug.',
  'sep.',
  'okt.',
  'nov.',
  'des.',
];

export function formatDateTime(ms: number): string {
  try {
    const s = new Intl.DateTimeFormat('nb-NO', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(ms));
    if (s.indexOf('.') !== -1 || /\d/.test(s)) return s;
  } catch {
    /* fall through */
  }
  const d = new Date(ms);
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${d.getDate()}. ${MONTHS[d.getMonth()] ?? ''} ${d.getFullYear()}, ${hh}:${mm}`;
}

export function formatClock(ms: number): string {
  const d = new Date(ms);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}
